const l = "_vertical_yl4l7_1", t = "_horizontal_yl4l7_5", o = {
  vertical: l,
  horizontal: t
};
export {
  o as default,
  t as horizontal,
  l as vertical
};
//# sourceMappingURL=styles.module.scss.js.map
